import { createSlice } from '@reduxjs/toolkit'

export const questionnaireMetadataSlice = createSlice({
  name: 'questionnaireMetadata',
  initialState: {},
  reducers: {
    SET_METADATA: (state, action) => {
      return action.payload.metadata
    },
    CLEAR_METADATA: (state, action) => {
      return {}
    },
  },
})

export const { SET_METADATA, CLEAR_METADATA } =
  questionnaireMetadataSlice.actions

export default questionnaireMetadataSlice.reducer
